import useTranslation from '../../hooks/useTranslation'
import Card from './Card'
import FullHeightContainer from '../../UI/FullHeightContainer/FullHeightContainer'
import Container from '../../UI/Container/Container'
import SlideInView from '../../UI/SlideInView/SlideInView'
import FloatingHeadline from '../../UI/FloatingHeadline/FloatingHeadline'
import Headline from '../ui/Headline'
import Text from '../ui/Text'
import brandschutz from '../../../assets/image/competences/brandschutz.jpeg'
import planung from '../../../assets/image/competences/planung.jpeg'
import statik from '../../../assets/image/competences/statik.jpeg'
import tga from '../../../assets/image/competences/tga.jpeg'

function CompetenceSection() {
  const t = useTranslation()
  const { kicker, heading, lead, items } = t.landing.competences
  const images = [planung, tga, brandschutz, statik]
  return (
    <FullHeightContainer center id="kompetenz">
      <div>
        <Container>
          <SlideInView>
            <div>
              <FloatingHeadline text={kicker} />
              <Headline headline={heading} size="xlarge" className="mt-7" />
              <Text text={lead} size="xlarge" className="mt-7" />
              <div className="flex flex-col md:flex-row gap-12 md:gap-6 mt-10">
                {items.map((item, index) => (
                  <Card key={item.title} item={{ ...item, image: images[index] }} />
                ))}
              </div>
            </div>
          </SlideInView>
        </Container>
      </div>
    </FullHeightContainer>
  )
}

export default CompetenceSection
